import { TextField } from "@material-ui/core";
import React, { Fragment } from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";
import moment from "moment";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import isEmpty from '../../../store/validation/is-Empty';
import { ORDER_STATUS, ORDER_TYPE, PAYMENT_TYPE, PAYMENT_STATUS } from '../../../enums/OrderEnums'

const calcTax = (data) => {
  let charges = 0;
  for (let j = 0; j < data.sur_charges.length; j++) {
    if (data.sur_charges[j].flag === "PERCENTAGE") {
      charges = ((data.size.price * data.quantity) * parseFloat(data.sur_charges[j].value)) / 100 + charges;
    } else {
      charges = (data.size.price * data.quantity) * parseFloat(data.sur_charges[j].value) + charges;
    }
  }
  return charges.toFixed(2);
};

const ViewMemo = (props) => {

  const memoData = useSelector((state) => {
    return !isEmpty(state.vendorOrdering?.memo_details) ? state.vendorOrdering?.memo_details : {};
  });

  return (
    <React.Fragment>
      <div className="container-fluid superadmin-orderscomponent-main super-admin-vendor-private-orders">
        <Row>
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>
          <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation />
            <div className="d-flex justify-content-between align-items-center pt-4 pb-4 ">
              <div className="f24_700_HelveticaNeue">View Memo</div>
            </div>
            <Container fluid>
              <Row className="mt-3">
                <Col xs={2}>
                  <div className="f12-500">
                    {`${memoData?.user_id?.first_name || ""} ${memoData?.user_id?.last_name || ""}`}
                  </div>
                  <div className="f12-400 mt-1">User Name</div>
                </Col>
                {memoData?.order_id && <Col xs={2}>
                  <div className="d-flex">
                    <div
                      className="d-flex align-items-center"
                      align="center"
                      style={{
                        backgroundColor: "#4CAF50",
                        borderRadius: "50%",
                      }}
                    >
                      <img
                        src={require("../../../assets/images/Icon/round-done-button.svg")}
                        width="50px"
                      />
                    </div>
                    <div>
                      <div className="f12-500">{ORDER_STATUS[memoData?.order_id?.order_status]}</div>
                      <div className="f12-400 mt-1">Latest Order Status</div>
                    </div>
                  </div>
                </Col>}
                <Col xs={2}>
                  <div className="f12-500">{memoData?.user_id?.country_code} {memoData?.user_id?.mobile_number}</div>
                  <div className="f12-400 mt-1">Mobile</div>
                </Col>
              </Row>
              <Row className="mt-4 mb-3">
                {memoData?.order_id && <Col md={8}>
                  <div className="f12-700">Order & Account Info</div>
                  <Row>
                    <Col md={4}>
                      <div className="mt-2">
                        <div className="f12-500">{moment(memoData?.order_id?.createdAt).format('lll')}</div>
                        <div className="f12-400">Creation Date & Time</div>
                      </div>
                      <div className="mt-2">
                        <div className="f12-500">{'-'}</div>
                        <div className="f12-400">Device ID</div>
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="mt-2">
                        <div className="f12-500">{memoData?.user_id?.email || ""}</div>
                        <div className="f12-400">User Email</div>
                      </div>
                      <div className="mt-2">
                        <div className="f12-500">{'-'}</div>
                        <div className="f12-400">Point of Entry</div>
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="mt-2">
                        <div className="f12-500">
                          {memoData?.user_id?.country_code} {memoData?.user_id?.mobile_number}
                        </div>
                        <div className="f12-400">User Phone Number</div>
                      </div>
                      <div className="mt-2">
                        <div className="f12-500">{'-'}</div>
                        <div className="f12-400">IP Address</div>
                      </div>
                    </Col>
                  </Row>
                </Col>}
                <Col md={12}>
                  <hr />
                </Col>
                <Col md={12}>
                  <div className="f12-700">Payment Info</div>
                  <Row>
                    <Col md={4}>
                      <div className="mt-2">
                        <div className="f12-500">{memoData?.payment_type || ""}</div>
                        <div className="f12-400">Payment Method</div>
                      </div>
                      <div className="mt-2">
                        <div className="f12-500">{memoData?.refund_amount}</div>
                        <div className="f12-400">Payment Amount</div>
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="mt-2">
                        <div className="f12-500">{memoData?.transactional_id || ""}</div>
                        <div className="f12-400">Payment Trans ID</div>
                      </div>
                      <div className="mt-2">
                        <div className="f12-500">{memoData?.payment_status || ""}</div>
                        <div className="f12-400">Payment Status</div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              {!isEmpty(memoData?.order_items) &&
                <Row className="mt-4">
                  <Col md={12}>
                    <div className="f12-700">Order Item List</div>
                    <div className="user-table-reusable-superadmin table-responsive">
                      <Table>
                        <thead>
                          <tr className="super_admin_all_users_table_head">
                            <th style={{ width: "10%" }} className="f12-700"></th>
                            <th style={{ width: "10%" }} className="f12-700">
                              Item Code
                             </th>
                            <th style={{ width: "10%" }} className="f12-700">
                              Item Description
                             </th>
                            <th style={{ width: "10%" }} className="f12-700">
                              Price
                            </th>
                            <th style={{ width: "10%" }} className="f12-700">
                              Qty
                             </th>
                            <th style={{ width: "10%" }} className="f12-700">
                              Item Status
                            </th>
                            <th style={{ width: "10%" }} className="f12-700">
                              Sub Total
                            </th>
                            <th style={{ width: "10%" }} className="f12-700">
                              Tax
                            </th>
                            <th style={{ width: "15%" }} className="f12-700">
                              Convenience Fee
                            </th>
                            <th style={{ width: "15%" }} className="f12-700">
                              Bag & Packing Fee
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {memoData.order_items.map((data, index) => {
                            return (
                              <Fragment key={index}>
                                <tr
                                  key={index}
                                  className="super_admin_all_users_table_body"
                                  style={{ wordBreak: "break-word" }}
                                >
                                  <td colSpan="7" className="p-0 w-100">
                                    <table className="w-100 HideShowTable enMinWidth900">
                                      <tbody>
                                        <tr>
                                          <td style={{ width: "10%" }}>
                                            <div className="f12-500">{data?.item?.id}</div>
                                          </td>
                                          <td style={{ width: "10%" }}>
                                            <div className="f12-400">{data?.item?.name}</div>
                                          </td>
                                          <td style={{ width: "10%" }}>
                                            <div className="f12-400">{`₹ ${data?.size?.price ? (data?.size?.price).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : 0}`}</div>
                                          </td>
                                          <td style={{ width: "10%" }}>
                                            <div className="f12-400">{data?.quantity}</div>
                                          </td>
                                          <td style={{ width: "10%" }}>
                                            <div className="f12-400">{data?.isCancelled ? "Cancelled" : data?.isSubstituted ? "Substituted" : "Accepted"}</div>
                                          </td>
                                          <td style={{ width: "10%" }}>
                                            <div className="f12-400">
                                              {`₹ ${data?.size?.price ? (data?.size?.price * data?.quantity).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : 0}`}
                                            </div>
                                          </td>
                                          <td style={{ width: "10%" }}>
                                            <div className="f12-400">
                                              {`₹ ${calcTax(data)}`}
                                            </div>
                                          </td>
                                          <td style={{ width: "15%" }}>
                                            <div className="f12-400">
                                              {"-"}
                                            </div>
                                          </td>
                                          <td style={{ width: "15%" }}>
                                            <div className="f12-400">
                                              {'-'}
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </Fragment>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>
                  </Col>
                </Row>
              }
              <Row className="mt-4">
                <Col md={6}>
                  <TextField
                    variant="outlined"
                    multiline
                    rows="4"
                    label="Comment here"
                    fullWidth
                    disabled
                    value={memoData?.comment || ""}
                  />
                </Col>

                <Col md={6}>
                  <div className="f14-500">Memo Total</div>
                  {memoData?.order_id ? <Row>
                    <Col md={6}>Sub Total</Col>
                    <Col md={6}>{memoData?.order_id?.base_amount || ""}</Col>
                    <Col md={6}>Discount</Col>
                    <Col md={6}>{'-'}</Col>
                    <Col md={6}>Tips</Col>
                    <Col md={6}>{memoData?.order_id?.tip?.amount || 0}</Col>
                    <Col md={6}>Donation</Col>
                    <Col md={6}>{memoData?.order_id?.donation?.amount || 0}</Col>
                    <Col md={6}>Grand Total</Col>
                    <Col md={6}>{memoData?.order_id?.total_amount}</Col>
                    <Col md={6}>Refund Totals</Col>
                    <Col md={6}>{memoData?.refund_amount + memoData?.adjustment_fee}</Col>
                    <Col md={6}>Adjustment Fee</Col>
                    <Col md={6}>{memoData?.adjustment_fee}</Col>
                    <Col md={6}>Net Refund</Col>
                    <Col md={6}>{memoData?.refund_amount}</Col>
                  </Row> :
                    <Row>
                      <Col md={6}>Refund Amount</Col>
                      <Col md={6}>{memoData?.refund_amount}</Col>
                    </Row>
                  }
                </Col>
              </Row>
            </Container>
          </div>
        </Row>
      </div>
    </React.Fragment>
  );
};


export default ViewMemo
